import React from 'react';

import { ICellRendererParams } from 'ag-grid-community';
import { Badge } from 'antd';

import { WiringResultItem } from '~apis/wiring';

interface Props extends ICellRendererParams<WiringResultItem> {}

export const wiringItemStatusRender = (status: 'SUCCESS' | 'WAITING' | 'FAILED') => {
  switch (status) {
    case 'SUCCESS':
      return <Badge status="success" text={'성공'} />;
    case 'WAITING':
      return <Badge status="warning" text={'대기'} />;
    case 'FAILED':
      return <Badge status="error" text={'실패'} />;
  }
};

const AGGridwiringStatusRenderer: React.FC<Props> = ({ data, value, node }) => {
  if (!data) {
    return null;
  }
  return wiringItemStatusRender(data.status);
};

export default AGGridwiringStatusRenderer;
